"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { Menu, X } from "lucide-react";
import { usePathname } from "next/navigation";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => setIsOpen(false), [pathname]);

  // UPDATED LINKS: Specific Services exposed directly
  const navLinks = [
    { name: "AWS", href: "/services/aws" },
    { name: "Gen AI", href: "/services/gen-ai" },
    { name: "Software", href: "/services/software" },
    { name: "Work", href: "/case-studies" },
    { name: "Articles", href: "/insights" },
      { name: "Company", href: "/company" },
  ];

  return (
    <header 
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm py-3" : "bg-white py-4 shadow-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
        
        {/* LOGO AREA */}
        <Link href="/" className="flex items-center gap-2 group">
          <img 
            src="/allcode.svg" 
            alt="AllCode" 
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* DESKTOP NAV */}
        <nav className="hidden md:flex items-center gap-6 lg:gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              href={link.href}
              className={`text-sm font-medium transition-colors hover:text-primary ${
                pathname.startsWith(link.href) 
                  ? "text-primary font-bold" 
                  : "text-slate-600"
              }`}
            >
              {link.name}
            </Link>
          ))}
          
          <Link 
            href="/contact" 
            className="px-5 py-2.5 bg-slate-900 text-white text-sm font-bold rounded-full hover:bg-primary transition-colors shadow-lg shadow-primary/20"
          >
            Get in Touch
          </Link>
        </nav>

        {/* MOBILE MENU BUTTON */}
        <button 
          className="md:hidden p-2 text-slate-600"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X /> : <Menu />}
        </button>
      </div>

      {/* MOBILE NAV DROPDOWN */}
      {isOpen && (
        <div className="absolute top-full left-0 w-full bg-white border-b border-slate-100 shadow-xl md:hidden flex flex-col p-4 animate-in slide-in-from-top-5">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              href={link.href}
              className="py-4 text-lg font-medium text-slate-600 border-b border-slate-50 last:border-0"
            >
              {link.name}
            </Link>
          ))}
          <Link 
            href="/contact" 
            className="mt-4 w-full text-center px-5 py-3 bg-primary text-white font-bold rounded-lg"
          >
            Get in Touch
          </Link>
        </div>
      )}
    </header>
  );
}